import { render } from "./AddressBook.vue?vue&type=template&id=2998f7d8&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"

import "./AddressBook.vue?vue&type=style&index=0&id=2998f7d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2998f7d8"]])

export default __exports__